<script lang="ts">
	import type { Snippet } from "svelte";
	import Navigation from "./Navigation.svelte";
	import Footer from "./Footer.svelte";

	let { children }: { children?: Snippet } = $props();
</script>

<header>
	<Navigation />
</header>
<main class="main-area">
	{@render children?.()}
</main>
<Footer />

<style>
	header {
		display: flex;
		flex-direction: row;
		justify-content: stretch;
		flex-wrap: wrap-reverse;
		color: white;
		background-color: var(--bs-dark-rgb) !important;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
	}

	.main-area {
		padding-top: 4rem;
	}
</style>
